function dmc_register_login_page() {
  var login_form_holder = $('#dmc-login-form-h');
  var recover_form_holder = $('#dmc-recover-form-h');
  $('#dmc-recover-cancel').click( function(e) {
    e.preventDefault();
    recover_form_holder.hide();
    login_form_holder.show();
  });
  $('#dmc-recover-open').click( function(e) {
    e.preventDefault();
    recover_form_holder.show();
    login_form_holder.hide();
  });




  
}
dmc_register_login_page();